(() => {
  document.querySelectorAll('[data-detail-open]').forEach(button => {
    if (button.dataset.ready) return;
    button.dataset.ready = 'true';
    const slide = button.closest('[data-gallery-slide]');
    const picture = slide.querySelector('picture');
    const image = picture?.querySelector('img');
    if (!image) return;
    let scale = 1, x = 0, y = 0, touchStart, gesture, loaded = false, suppressClick = false, blockGallery = false;
    const clamp = (n,a,b) => Math.max(a,Math.min(b,n));
    const paint = () => {
      x = clamp(x,-picture.clientWidth*(scale-1)/2,picture.clientWidth*(scale-1)/2);
      y = clamp(y,-picture.clientHeight*(scale-1)/2,picture.clientHeight*(scale-1)/2);
      image.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
      picture.classList.toggle('is-detail-zoomed',scale>1);
      button.setAttribute('aria-pressed',String(scale>1));
      button.setAttribute('aria-label',scale>1?'Ponastavi povečavo':'Povečaj fotografijo izdelka');
      button.querySelector('span').textContent = scale>1?'Pomanjšaj':'Povečaj';
    };
    const warm = () => {
      if(loaded) return; loaded=true;
      const high = new Image(); high.src=button.dataset.src;
      high.onload=()=>{ picture.querySelectorAll('source').forEach(s=>s.srcset=high.src); image.srcset=high.src; image.src=high.src; };
    };
    const reset=()=>{scale=1;x=0;y=0;gesture=null;paint();};
    const toggle=()=>{warm();if(scale>1)reset();else{scale=2.5;paint();}};
    button.addEventListener('click',toggle);
    picture.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){warm();scale=2.5;paint();}});
    picture.addEventListener('pointermove',e=>{
      if(e.pointerType!=='mouse'||scale===1)return;
      const r=picture.getBoundingClientRect();
      x=(r.width/2-(e.clientX-r.left))*(scale-1);
      y=(r.height/2-(e.clientY-r.top))*(scale-1);paint();
    });
    picture.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse')reset();});
    picture.addEventListener('click',e=>{if(suppressClick){suppressClick=false;return;}if(e.pointerType!=='mouse')toggle();});
    const center=t=>({x:(t[0].clientX+t[1].clientX)/2,y:(t[0].clientY+t[1].clientY)/2});
    const distance=t=>Math.hypot(t[0].clientX-t[1].clientX,t[0].clientY-t[1].clientY);
    picture.addEventListener('touchstart',e=>{
      blockGallery = scale > 1 || e.touches.length > 1;
      warm();touchStart={x:e.touches[0].clientX,y:e.touches[0].clientY};suppressClick=false;
      if(e.touches.length===2){e.preventDefault();e.stopPropagation();gesture={distance:distance(e.touches),scale,center:center(e.touches),x,y};}
      else if(scale>1){e.stopPropagation();gesture={x,y,center:touchStart};}
    },{passive:false});
    picture.addEventListener('touchmove',e=>{
      if(touchStart && Math.hypot(e.touches[0].clientX-touchStart.x,e.touches[0].clientY-touchStart.y)>8)suppressClick=true;
      if(e.touches.length===2 && gesture?.distance){
        e.preventDefault();e.stopPropagation();suppressClick=true;
        scale=clamp(gesture.scale*distance(e.touches)/gesture.distance,1,4);
        const c=center(e.touches);x=gesture.x+c.x-gesture.center.x;y=gesture.y+c.y-gesture.center.y;paint();
      }else if(scale>1 && gesture){
        e.preventDefault();e.stopPropagation();x=gesture.x+e.touches[0].clientX-gesture.center.x;y=gesture.y+e.touches[0].clientY-gesture.center.y;paint();
      }
    },{passive:false});
    picture.addEventListener('touchend',e=>{if(blockGallery)e.stopPropagation();if(!e.touches.length){gesture=null;touchStart=null;}});
    picture.addEventListener('touchcancel',()=>{gesture=null;touchStart=null;suppressClick=true;});
    new MutationObserver(()=>{if(!slide.classList.contains('active'))reset();}).observe(slide,{attributes:true,attributeFilter:['class']});
    button.addEventListener('keydown',e=>{if(e.key==='Escape')reset();});
    paint();
  });
})();
